import {
	Loader,
} from '@tfo/common'
import { observer } from 'mobx-react'
import * as React from 'react'
import { useReportStore } from '../hooks/useReportStore'
import { IntlProviderWrapper } from '../IntlProviderWrapper'
import ReadReportCore from './ReadReportCore'
import RootStore from '../stores/RootStore'
import { Elements } from '@tfo/common'
import { FormattedMessage } from 'react-intl'

const { Heading1,Paragraph } = Elements

const ReadReport = observer(({ closeReport }: { closeReport?: () => void }) => {
	const store = useReportStore<RootStore>()
	const reportStore = store.reportStore

	const isLoaded = !!reportStore?.initialDataLoaded
	const hasAccess = !!reportStore?.order

	return <>
		{isLoaded && hasAccess &&
			<IntlProviderWrapper languageSettings={{ language: reportStore.order.language }}>
				<ReadReportCore closeReport={closeReport} store={store} />
			</IntlProviderWrapper>
		}
		{isLoaded && !hasAccess && <NoAccess />}
		{!isLoaded && <Loader />}
	</>
})

const NoAccess = () => {
	return (
		<div className="ReadReport__no-access--container">
			<Heading1 className="ReadReport__no-access--header">
				<FormattedMessage id="report.no-access.header" />
			</Heading1>
			<Paragraph>
				<FormattedMessage
					id="report.no-access.header.sub"
					values={{
						link: (
							<a href="/reports">
								<FormattedMessage id="report.no-access.header.reports" />
							</a>
						)
					}}
				/>
			</Paragraph>
		</div>
	)
}

export default ReadReport
